<template>
    <div class="sip-footer-content d-flex align-items-center justify-content-between w-100">
        <span class="sip-footer-copy">
            Copyright &copy; {{ currentYear }} Sipinor Educational Solutions. All rights reserved.
        </span>
        <span class="sip-footer-credit text-muted d-none d-sm-inline">
            Made with Love &amp; Care in Pink City.
        </span>
    </div>
</template>

<script>
export default {
    name: 'app-footer',
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    }
}
</script>
